import { CreateButton } from "@/components/admin/create-button";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Plus, Users } from "lucide-react";
import { useTranslate } from "ra-core";

import useAppBarHeight from "../misc/useAppBarHeight";
import { ContactImportButton } from "./ContactImportButton";
import { ContactCreateSheet } from "./ContactCreateSheet";
import { useIsMobile } from "@/hooks/use-mobile";

export const ContactEmpty = () => {
  const appbarHeight = useAppBarHeight();
  const isMobile = useIsMobile();
  const translate = useTranslate();
  const [createOpen, setCreateOpen] = useState(false);
  return (
    <>
      <ContactCreateSheet open={createOpen} onOpenChange={setCreateOpen} />
      <div
        className="flex flex-col justify-center items-center gap-6"
        style={{ height: `calc(100dvh - ${appbarHeight}px)` }}
      >
        {/* Icon */}
        <div
          className="w-16 h-16 rounded-2xl flex items-center justify-center"
          style={{ background: "rgba(62,207,142,0.08)" }}
        >
          <Users className="w-7 h-7" style={{ color: "#3ECF8E" }} />
        </div>

        {/* Text */}
        <div className="flex flex-col items-center gap-1 text-center max-w-xs">
          <h6 className="text-[16px] font-bold text-[#0F1629]">
            No patients yet
          </h6>
          <p className="text-[13px] text-slate-400 leading-relaxed">
            Patient records are created automatically when Sera books a new appointment, or you can add one manually.
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-row gap-2">
          {isMobile ? (
            <Button
              onClick={() => setCreateOpen(true)}
              className="gap-2 rounded-xl font-semibold text-[13px]"
              style={{ background: "#3ECF8E", color: "white", border: "none" }}
            >
              <Plus className="h-4 w-4" />
              Add patient
            </Button>
          ) : (
            <>
              <CreateButton label="resources.contacts.action.new" />
              <ContactImportButton />
            </>
          )}
        </div>
      </div>
    </>
  );
};
